import { EMPTY_GUID } from '../../../../constants';
import { AddressBook, AddressBookFolderEnum } from '../../../../generated';

export const isValidProvider = (address: AddressBook) => {
  return (
    address.userDetailID !== EMPTY_GUID &&
    address.addressBookFolderEnum === AddressBookFolderEnum.Provider
  );
};
